import { AnimatePresence, motion } from 'framer-motion';

import { useBroadcast } from './hooks/useBroadcast';

import Advt from './components/Advt/Advt';
import Slide from './components/Slide/Slide';
import Message from './components/Message/Message';

import posterDefault from './assets/images/bgPoster.webp';
import bgDefaultVideo from './assets/video/bgVideo.webm';

function App() {
  const { currentState, currentMessage, currentMessageF2 } = useBroadcast();

  return (
    <div className="app-wrapper">
      <AnimatePresence mode="popLayout">
        {currentState === 'S1' && (
          <motion.div
            style={{ width: '100%', height: '100vh' }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
            exit={{ y: '-100vh' }}
          >
            <Advt />
          </motion.div>
        )}

        {currentState === 'S2' && (
          <motion.div
            style={{ width: '100%', height: '100vh' }}
            key={`${currentState}-slide`}
            initial={{ y: '100vh' }}
            animate={{ y: '0' }}
            transition={{ duration: 0.5 }}
            exit={{ opacity: 0 }}
          >
            <Slide
              message={currentMessage?.message}
              messageF2={currentMessageF2?.message}
              rotateSign={currentMessageF2?.rotateSign}
            />
          </motion.div>
        )}

        {currentState === 'S3' && (
          <motion.div
            style={{ width: '100%', height: '100vh' }}
            key={`${currentState}-msg`}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
            exit={{ opacity: 0 }}
          >
            <Message
              message={currentMessage?.message}
              messageF2={currentMessageF2?.message}
              rotateSign={currentMessageF2?.rotateSign}
            />
          </motion.div>
        )}
      </AnimatePresence>

      <video
        autoPlay="autoplay"
        muted="muted"
        loop
        id="bgVideo"
        poster={posterDefault}
      >
        <source src={bgDefaultVideo} type="video/webm" />
      </video>

      <div id="img-loader"></div>
    </div>
  );
}

export default App;
